import appDisplay from 'scoreboard/components/app-display'
import configBackground from '../wob-background-menu'
import i18n from 'scoreboard/components/i18n'
import FilterWizard from 'scoreboard/datasets/filters/filter-wizard'
import ConfigDatasetFilterLabel from './config-dataset-filter-label'
import WidgetConfigMenu from '../widget-config-menu'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'

const DatasetFilterWidgetConfig = WidgetConfigMenu.extend({
	width: 250,
	configSize: { width: true, height: false },

	/** @type {DatasetFilterWidget} */
	model: null,

	typeSpecificTargets: function (hasTemplate) {
		let datasetId = this.model.properties.get('datasetId')
		let dataset = this.model.data.datasetModel(datasetId)

		let genericTargets = [ configBackground(this.model.properties) ]

		if (!dataset.get('view')) {
			return genericTargets
		}

		let edit = {
			type: 'dialog',
			label: 'report.designer.setDataSource',
			target: (e) => {
				e.preventDefault()
				e.stopPropagation()

				let wizard = new FilterWizard({
					model: dataset,
					lockField: false,
					filter: this.model.filter(),
					title: i18n.get('datasets.filters.set'),
					allowIncomplete: true,
					allowAllTime: true,
					allowAppCalendar: true,
					parentDomainType: 'dashboard',
					showDatasetButton: true,
					showDatasetLink: true
				}).start()
				wizard.on('done', (revisedFilter, treeItems, dataset) => {
					let previousDatasetId = this.model.datasetId()
					this.model.data.datasetModel(dataset.id, dataset)

					// If the filter involved a tree, the original dashboard data
					// (ie model.data) might not have the tree (the dataset field might
					// not have originally been used, so the tree wouldn't be loaded).
					// So that future rendering has access to the selected tree items,
					// make sure they are in model.data
					if (revisedFilter.fieldId && treeItems && treeItems.length > 0) {
						let field = dataset.getUnderlyingField(revisedFilter.fieldId)
						if (field && field.treeId) {
							let treeId = field.treeId

							if (treeId) {
								treeItems.forEach(item => this.model.data.datasetTreeItems(item.id, item))
							}
						}
					}

					this.model.filter(revisedFilter, { datasetId: dataset.id })

					// Set updated filter to DatasetFilterWidgetView, which
					// takes care of triggering any necessary data fetches
					let widgetView = this.options.widgetUpdater
						.widgetViewsByModelCid()[this.model.cid]
					widgetView.onFilterUpdate(revisedFilter, treeItems, dataset,
						previousDatasetId)
				})
			}
		}

		let title = {
			type: 'dialog',
			label: 'dashboards.setTitle',
			target: e => {
				let configView = new ConfigDatasetFilterLabel({
					model: this.model
				})

				appDisplay.dialog(configView)

				e.preventDefault()
				this.trigger('done')
			}
		}

		let showFilterType = {
			type: 'toggle',
			label: i18n.get('dashboards.datasets.showFilterType'),
			contentView: FilterTypeToggle,
			model: this.model.properties
		}

		return [
			edit,
			title,
			showFilterType
		].concat(genericTargets)
	}
})

const FilterTypeToggle = BootslideMenu.WidgetToggleProperty.extend({
	property: {
		name: 'showFilterType',
		label: 'dashboards.datasets.showFilterType'
	}
})

export default DatasetFilterWidgetConfig

DatasetFilterWidgetConfig.__filename__ = 'dashboards/widgets/dataset-filter/dataset-filter-widget-config.js'
